export default __webpack_public_path__ + "static/media/1641.49bd5b6f.jpg";